// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"218":"1da72c1912ca07671c26","532":"6eb47bb1eef6b02920cc","691":"fd2da451d04c6948b472","954":"a6b308bb5cfcded8ad55"}[chunkId] + ".js";
};